<template>
    <layout>
        <TitleLable parentMessage="学生管理" :showback="true"></TitleLable>
        <el-select size="small" @change="changeSelect" v-model="plan_id" placeholder="请选择">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <el-button style="float: right;" size="small" @click="changeCharts" class="el-icon-s-data" type="primary"> {{ tabel_text }}</el-button>
        <div class="top_box">
            <div class="top_name">
                <span style="color: #409EFF;" class="el-icon-tickets"> 成绩总览</span>
                <el-row>
                    <el-col :span="4">
                        <div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.averageScore }}</span>
                            <span style="font-size: 14px;opacity: 0.6;"> / {{ examgrade_data.getTotalScore }}</span>
                        </div>
                        <div class="grade_bottom">平均成绩/总分</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.max }}</span>
                        </div>
                        <div class="grade_bottom">最高分</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.min }}</span>
                        </div>
                        <div class="grade_bottom">最低分</div>
                    </el-col>
                    <el-col :span="4"><div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.averageScore }}</span>
                        </div>
                        <div class="grade_bottom">平均分</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.number }}</span>
                            <span style="font-size: 14px;opacity: 0.6;"> / {{ examgrade_data.total_number }}</span>
                        </div>
                        <div class="grade_bottom">实考人数/总人数</div>
                    </el-col>
                    
                    <!-- <el-col :span="4">
                        <div class="grade_top">
                            <span style="font-weight: 700;color: #409EFF;font-size: 20px;">{{ examgrade_data.averageTime }}</span>
                            <span style="font-size: 14px;opacity: 0.6;"> / {{ examgrade_data.examtime }}</span>
                        </div>
                        <div class="grade_bottom">平均作答时长（分钟）</div>
                    </el-col> -->
                </el-row>
            </div>
        </div>
        <div v-if="tabel == 0">
            <div class="oprion_">
                <el-input size="small" @input="changeKeyword" v-model="keyword" placeholder="请输入学生姓名"></el-input>
                <el-button type="primary" size="small" @click="userMessage" style="margin-right: 15px;" class="el-icon-edit"> 发布补考</el-button>
                <el-button type="primary" size="small" @click="settingExamtime" style="margin-right: 15px;" class="el-icon-setting"> 设置延时</el-button>
                <el-button type="danger" @click="downExcel" size="small" class="el-icon-download"> 导出成绩</el-button>
            </div>
            <el-table
                :data="tableData"
                ref="multipleTable"
                border
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="stuid"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="score"
                    label="分数">
                </el-table-column>
                <el-table-column
                    prop="write"
                    label="批改状态">
                </el-table-column>
                <el-table-column
                    
                    label="状态">
                    <template slot-scope="scope">
                
                        <div slot="reference" class="name-wrapper">
                            <span :style="scope.row.state_text == '已提交'?'':'color:red'">{{ scope.row.state_text }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="320">
                    <template slot-scope="scope">
                        <el-button
                        size="mini"
                        class="el-icon-document"
                        @click="handlePaper(scope.row.name, scope.row.uid)"> 查看试卷</el-button>

                        <el-button
                        size="mini"
                        type="primary"
                        class="el-icon-download"
                        @click="downloadFile(scope.$index, scope.row)"> 导出试卷</el-button>
                        <el-button
                        size="mini"
                        type="danger"
                        class="el-icon-monitor"
                        @click="handleCorrect(scope.$index, scope.row)"> 批改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        

        <el-dialog
            title="班级考试延时设置"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
                <div class="content_paper">
                    
                    <el-input v-model="end_time" placeholder="请输入延长时间（分钟）"></el-input>
                    
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="submitExamTime">确认设置</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="设置补考时间"
            :visible.sync="dialogVisibleuserMessage"
            width="50%"
            :before-close="handleCloseuserMessage">
                <div class="content_paper">
                    <el-input v-model="title" style="margin-bottom: 20px;" placeholder="请输入补考通知名称"></el-input>
                    <el-date-picker
                        v-model="date"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                    
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogVisibleuserMessage = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="sendUserMessage">确认设置</el-button>
                </span>
        </el-dialog>
        <el-dialog
            class="paper_write"
            :title="`${user_name} 试卷`"
            :visible.sync="dialogVisiblejob"
            width="50%"
            :before-close="handleClosejob">
                <div class="content_paper">
                    <div v-for="(item,index,pindex) in paper" :key="pindex">
                        <el-card style="margin-bottom: 20px;" shadow="never">
                            <h3 style="color: #409EFF;">{{ item.type_text }} 总分：{{ item.fraction }}</h3>
                            <div class="" v-for="(qitem,qindex,outindex) in item.content" :key="outindex">
                                <h4>{{ item.type_text }} {{ outindex+1 }}</h4>

                                <div class="declare" style="margin-bottom: 10px;">
                                    <div v-html="qitem.declare"></div>
                                </div>
                                <div v-html="qitem.body"></div>

                                <div style="margin-top: 15px;">
                                    <span style="color: #f56c6c;width: 100%;display: inline-block;margin-bottom: 10px;">参考答案：</span>
                                    <div v-html="qitem.answer"></div>
                                </div>
                                <div style="margin-top: 15px;margin-bottom: 20px;">
                                    <span style=" font-weight: 700;color: #000000;margin-bottom: 10px;width: 100%;display: inline-block;">学生答案：</span>
                                    <div v-html="qitem.subanswer"></div>
                                    <div v-if="!qitem.subanswer">未做题</div>
                                </div>
                                <el-input v-model="score[index][qindex]" placeholder="请输入分数"></el-input>
                            </div>
                        </el-card>
                    </div>
                    <div @click="submitScore" style="display: inline-block;width: 100%;text-align: center;margin-top: 15px;"><el-button size="small" type="primary" class="el-icon-edit-outline"> 确认打分</el-button></div>
                    
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" @click="nexstudent(0)" class="el-icon-arrow-left"> 上一位同学</el-button>
                    <el-button size="small" type="primary" @click="nexstudent(1)" >下一位同学 <i class="el-icon-arrow-right"></i></el-button>
                </span>
        </el-dialog>

        <!-- 查看学生试卷 -->
        <div class="paperdialog">
            <el-dialog
            :title="`${paper_name} 试卷`"
            :visible.sync="dialogVisiblePaper"
            width="40%"
            :before-close="handleClose">
            <div v-for="(item, index) in bank_data" :key="index" class="content_paper">
                <div v-for="(test_item, test_index,a_index) in item" :key="a_index">
                    <h4 style="color: #f56c6c;">{{ type_data[index] }} {{ a_index + 1 }}</h4>
                    <div class="declare">
                        <h4>Directions:</h4>
                        <div class="declare_html" v-html="test_item.declare"></div>
                    </div>
                    <div style="color: #000000;line-height: 25px;padding: 12px;" v-html="test_item.body"></div>

                    <div v-show="['1', '2', '3', '9'].includes(index)" v-for="(questionitem, questionindex,q_index) in test_item.test" :key="questionindex" class="readtest" style="padding: 12px;">
                        <div>
                            <h4 style="color: #000000;">{{ q_index + 1 }}. {{ questionitem.question }}</h4>
                            <div 
                                :style="!answeritem || answeritem === '/' ? 'display:none' : ''" 
                                v-for="(answeritem, answerindex) in questionitem.answer" 
                                :key="answerindex" 
                                :class="['question_test', { activ: isAnswerMatch(index, test_index, questionindex, answerindex) }]"
                            >
                                {{ paper_options[answerindex] }}. {{ answeritem }}
                            </div>
                            <div style="font-weight: 700;">
                                <span style="color: #f56c6c;">正确答案：</span>
                                <span style="color: #f56c6c;">{{ questionitem.r_answer }}</span>
                                
                            </div>
                            <div style="display: inline-block;width: 100%;margin-top: 15px;font-weight: 700;">
                                <span style="color: #000000;">学生答案：</span>
                                <span class="answer_item" >{{ subanswer[index] != null?subanswer[index][test_index][questionindex]:'未作答'}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="['4', '5'].includes(index)" style="padding: 12px;">
                        <div style="display: inline-block;width: 100%;">
                            <span style="color: #000000;">正确答案：</span>
                            <span class="answer_item" v-for="(answer_item, answer_index) in test_item.answer" :key="answer_index">{{ answer_index + 1 }}. {{ answer_item }}</span>
                        </div>
                        <div style="display: inline-block;width: 100%;margin-top: 15px;">
                            <span style="color: #f56c6c;">学生答案：</span>
                            <span class="answer_item" v-for="(answer_item, answer_index) in getMyAnswers(index, test_index)" :key="answer_index">{{ answer_index + 1 }}. {{ answer_item }}</span>
                        </div>
                    </div>
                    <div v-show="['6', '7'].includes(index)" style="padding: 12px;">
                        <div style="display: inline-block;width: 100%;">
                            <span style="color: #000000;">参考答案：</span>
                            <span>{{ test_item.answer }}</span>
                        </div>
                        <div style="display: inline-block;width: 100%;margin-top: 15px;">
                            <span style="color: #f56c6c;">学生答案：</span>
                            <span>{{ getMySingleAnswer(index, test_index) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            </el-dialog>
        </div>



        <Echarts v-if="tabel == 1" ref="chart"></Echarts>
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Echarts from '../../units/Charts.vue';
import Http from "../../apis/teach";
import axios from 'axios';
export default {

    components:{
        TitleLable,
        Echarts
    },
    data(){
        return{
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dialogVisibleuserMessage:false,
            dialogVisiblejob:false,
            date:'',
            title:'',
            tabel_text:'图标统计',
            tabel:0,
            end_time:'',
            dialogVisible:false,
            options: [],
            tableData: [],
            plan_id:0,
            trem:'',
            examgrade_data:[],
            exam_id:'',
            uids:[],
            paper:[],
            score:{},
            student_index:0,
            student_ids:[],
            user_name:'',
            keyword:'',
            dialogVisiblePaper:false,
            bank_data:[],
            subanswer:[],
            type_data:{1:'单项选择',2:"阅读理解",3:"完型填空",4:"匹配题",5:"单词变形",6:"写作题",7:"翻译题",8:"听力题",9:"判断题"},
            paper_options: ['A', 'B', 'C', 'D'],
            nid:0,
            paper_name:''
        }
    },
    activated(){
        this.trem = this.$route.query.trem
        this.plan_id = parseInt(this.$route.query.plan_id)
        this.exam_id = this.$route.query.exam_id
        this.nid = this.$route.query.nid
        this.getplan()
        this.getStudent()
        this.getOverview()

        
    },
    methods:{
        isAnswerMatch(index, test_index, questionindex, answerindex) {
            if (
                this.subanswer[index] &&
                this.subanswer[index][test_index] &&
                this.subanswer[index][test_index][questionindex]
            ) {
                return this.subanswer[index][test_index][questionindex] === this.options[answerindex];
            }
            return false;
        },
        getMyAnswers(index, test_index) {
            if (this.subanswer[index] && this.subanswer[index][test_index]) {
                return this.subanswer[index][test_index];
            }
            return [];
        },
        getMySingleAnswer(index, test_index) {
            if (this.subanswer[index] && this.subanswer[index][test_index]) {
                return this.subanswer[index][test_index].answer;
            }
            return '';
        },
        downloadFile(index, item) {
            const fileUrl = `${axios.defaults.baseURL}/api/teach/downExam?token=${localStorage.getItem("token")}&uid=${item.uid}&trem=${this.trem}&nid=${item.nid}`;

            location.href = fileUrl
        },
        nexstudent(type){
            if(type){
                this.student_index++;
            }else{
                this.student_index--;
            }
            if(!this.student_ids[this.student_index]){
                this.$message({
                    message:'没有更多了',
                    type:'error'
                })
            }else{
                this.getdojob(this.student_ids[this.student_index])
            }
        },

        submitScore(){
            var key = Object.keys(this.paper)

            var row = {}
            for(var index in key){
                var score = this.score[key[index]]
                row[key[index]] = score
            }

            
            console.log(row)
            var params = {}
            params.score = row
            params.id = key
            Http.correctWork(params).then((res) => {
                this.$message({
                        message:res.msg,
                        type:'error'
                    })
                this.getStudent()

            });
        },

        changeCharts(){
            this.tabel = this.tabel?0:1;
            this.tabel_text = !this.tabel?'图表统计':'表格'
            if(this.tabel == 1){
                setTimeout(()=>{
                    this.$refs.chart.getChartData(this.trem,this.plan_id)
                },200)
            }
        },
        changeSelect(e){
            this.plan_id = e
            this.getStudent()
            this.getOverview()
        },
        getplan(){
            var params = {}
            params.trem = this.trem
            Http.examPlan(params).then((res) => {
                //this.plan_id = res.data[0].value
                this.options = res.data
            });
        },

        changeKeyword(){

            this.getStudent()
        },
        getStudent(){
            // const loading = this.$loading({
            //     lock: true,
            //     text: '请耐心等待...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.4)'
            // });
            var params = {}
            params.trem = this.trem
            params.plan_id = this.plan_id
            params.exam_id = this.exam_id
            params.keyword = this.keyword
            Http.student(params).then((res) => {
                var data = res.data
                var ids = []
                for(var index in data){
                    ids.push(data[index].uid)
                }
                this.student_ids = ids
                //loading.close()
                this.tableData = data
            });
        },
        getOverview(){
            var params = {}
            params.trem = this.trem
            params.plan_id = this.plan_id
            params.exam_id = this.exam_id
            Http.overview(params).then((res) => {
                this.examgrade_data = res.data

            });
        },
        submitExamTime(){
            var params = {}
            params.exam_id = this.exam_id
            params.end_time = this.end_time
            Http.updateExamtime(params).then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                });
                if(res.code){
                    this.dialogVisible = false
                }
            });
        },
        handleCloseuserMessage(){
            this.dialogVisibleuserMessage = false
        },
        userMessage(){
            if(!this.uids.length){
                this.$message({
                    type: 'error',
                    message:'请先选择需要补考的学生'
                });
                return false;
            }
            this.dialogVisibleuserMessage = true
        },
        sendUserMessage(){
            if(!this.date){
                this.$message({
                    showClose: true,
                    message: '请先设置考试时间',
                    type: 'error'
                });
                return false;
            }

            const start_time = this.$Common.newDateFormat_(this.date[0])
            const end_time = this.$Common.newDateFormat_(this.date[1])
            var params = {}
            params.plan_id = this.plan_id
            params.trem = this.trem
            params.uid = this.uids
            params.nid = this.nid
            params.title = this.title
            params.start_time = start_time
            params.end_time = end_time
            Http.userMessage(params).then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                });
                if(res.code){
                    this.title = ''
                    this.date = ''
                    this.$refs.multipleTable.clearSelection();
                    this.dialogVisibleuserMessage = false
                }
            });
            
        },  
        settingExamtime(){
            this.dialogVisible = true
        },
        handleSelectionChange(e){
        
            var result = e.map((item,index) => {
                return item.uid
            });
            this.uids = result
        },
        handleClose(){
            this.dialogVisible = false
        },
        handleEdit(){

        },
        handleCorrect(index,item){
            this.student_index = index
            this.getdojob(item.uid)
            
            
        },
        handlePaper(name,student_id){
            this.paper_name = name
            var params = {}
            params.trem = this.trem
            params.student_id = student_id
            Http.studentExam(params).then((res) => {
                this.bank_data = res.data.row
                this.subanswer = res.data.subanswer
                this.dialogVisiblePaper = true
            });
            
        
        },
        handleClose(){
            this.dialogVisiblePaper = false
        },
        getdojob(uid){
            var params = {}
            params.trem = this.trem
            params.student_id = uid
            Http.dojob(params).then((res) => {
                if(!res.code){

                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                    return false;
                }else{
                    this.dialogVisiblejob = true
                }
                
                var data  = res.data.result
                this.user_name = res.data.name
                this.paper = data
                
                for(var index in data){
                    this.$set(this.score,index,{})

                    for(var i in data[index].content){

                        this.$set(this.score[index],i,data[index].content[i].score)
                    }
                }
            });

        },
        handleClosejob(){
            this.dialogVisiblejob = false
        },
        downExcel(){
            const fileUrl = `${axios.defaults.baseURL}/api/teach/downExcelFile?token=${localStorage.getItem("token")}&plan_id=${this.plan_id}&trem=${this.trem}&nid=${this.exam_id}`;  

            location.href = fileUrl
        }
    }
}
</script>
<style lang="less" scoped>
.paperdialog::v-deep .el-dialog__header{
    font-weight: 700 !important;
}
.answer_item{
    display: inline-block;
    padding: 5px 10px;
    color: #409EFF;
    background: #F6F7FB;
    margin-right: 5px;
    border-radius: 5px;
}

.question_test{
    width: 100%;
    display: inline-block;
    line-height: 25px;
    box-sizing: border-box;
    color: #409EFF;
    background: #F6F7FB;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.activ{
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
    font-weight: 700;
}
.declare{
    margin: 0 auto;
    background: #EAF5FB;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 5px;

    .declare_html{
        font-size: 14px;
        line-height: 28px;
    }
}
.top_box{
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    background-color: #F6F7FB;
    border-radius: 5px;
    margin-top: 20px;

    .top_name{
        display: inline-block;
        width: 100%;
    }
    .grade_top{
        display: inline-block;
        width: 100%;
        line-height: 32px;
    }
    .grade_bottom{
        display: inline-block;
        width: 100%;
        line-height: 32px;
        font-size: 14px;
    }
}
.top_name::v-deep .el-col{
    text-align: center;
    box-sizing: border-box;
    padding: 15px 0px;
}
.oprion_{
    display: inline-block;
    width: 100%;
    text-align: right;
    margin-top: 20px;
    margin-bottom: 20px;
}
.content_paper{
    width: 100%;
}
.paper_write::v-deep .el-dialog__title{
    color: #F56C6C;
    font-weight: 700;
}
.oprion_::v-deep .el-input{
    width: 200px;
    margin-right: 20px;
}
</style>